import { useTokenStore } from "core/features/auth/hooks/useTokenStore";
import { api } from "infra/axios";
import { useQuery } from "react-query";

export function useIngressosAbertos() {
  const url = `/v1/ingressos/meus-ingressos/abertos`;
  const token = useTokenStore((state) => state.token?.access_token);

  return useQuery(url, async () => {
    const { data } = await api.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  });
}
